var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "agenda-form"
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" " + _vm._s(_vm.isUpdate ? "Editar Agendamento" : "Novo Agendamento") + " ")])])]), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('div', {
    staticClass: "agenda-steps mb-8"
  }, _vm._l(_vm.steps, function (item) {
    return _c('button', {
      key: item.id,
      staticClass: "agenda-step",
      class: {
        active: _vm.step === item.id,
        done: _vm.step > item.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.goToStep(item.id);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.id))]), _vm._v(" " + _vm._s(item.label) + " ")]);
  }), 0), _vm.step === 1 ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "cliente"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    attrs: {
      "label": "nome",
      "filterable": false,
      "options": _vm.clientes,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setCliente,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('span', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.nome))]), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.nome) + " ")];
      }
    }], null, false, 2815673665),
    model: {
      value: _vm.form.cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cliente", $$v);
      },
      expression: "form.cliente"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do cliente")])], 2), _c('button', {
    staticClass: "btn btn-light-primary btn-sm font-weight-bold mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openNovoClienteModal
    }
  }, [_vm._v(" Novo Cliente ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Responsável da agenda"
    }
  }, [_vm.currentUser.admin ? _c('VueSelect', {
    ref: "buscarUsuario",
    attrs: {
      "label": "nome",
      "filterable": false,
      "options": _vm.usuarios,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setUsuario,
      "search": _vm.onSearchUsuario
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(_vm.usuarioLabel(option)) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(_vm.usuarioLabel(option)) + " ")];
      }
    }], null, false, 183920173),
    model: {
      value: _vm.form.usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "usuario", $$v);
      },
      expression: "form.usuario"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do usuário ")])], 2) : _c('b-form-input', {
    attrs: {
      "value": _vm.responsavelLabel,
      "disabled": ""
    }
  })], 1)], 1)], 1), _vm.form.cliente ? _c('div', {
    staticClass: "cliente-resumo mb-6"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.form.cliente.nome))]), _vm.form.cliente.cnpj_cpf ? _c('span', {
    staticClass: "text-muted d-block"
  }, [_vm._v(" " + _vm._s(_vm.formatCpfCnpj(_vm.form.cliente.cnpj_cpf)) + " ")]) : _vm._e()]), _vm.clienteTelefone ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Telefone: " + _vm._s(_vm.clienteTelefone) + " ")]) : _vm._e(), _vm.clienteEmail ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" E-mail: " + _vm._s(_vm.clienteEmail) + " ")]) : _vm._e()]) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Título interno",
      "label-for": "titulo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "titulo",
      "placeholder": "Opcional"
    },
    model: {
      value: _vm.form.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "titulo", $$v);
      },
      expression: "form.titulo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Duração",
      "label-for": "duracao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "duracao",
      "type": "number",
      "min": "1",
      "max": "1440",
      "step": "1",
      "placeholder": "Minutos"
    },
    on: {
      "input": _vm.changeDuration
    },
    model: {
      value: _vm.form.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "duracao_minutos", _vm._n($$v));
      },
      expression: "form.duracao_minutos"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Observações",
      "label-for": "observacoes"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "observacoes",
      "rows": "2"
    },
    model: {
      value: _vm.form.observacoes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacoes", $$v);
      },
      expression: "form.observacoes"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.step === 2 ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "agenda-calendar-header"
  }, [_c('button', {
    staticClass: "btn btn-light btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.moveDate(-1);
      }
    }
  }, [_c('ChevronLeft', {
    attrs: {
      "size": 20
    }
  })], 1), _c('b-form-input', {
    staticClass: "agenda-date-input",
    attrs: {
      "type": "date"
    },
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: _vm.form.data,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data", $$v);
      },
      expression: "form.data"
    }
  }), _c('button', {
    staticClass: "btn btn-light btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.moveDate(1);
      }
    }
  }, [_c('ChevronRight', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setToday
    }
  }, [_vm._v(" Hoje ")]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.searchingNextAvailable
    },
    on: {
      "click": _vm.goToNextAvailableDate
    }
  }, [_vm._v(" " + _vm._s(_vm.searchingNextAvailable ? "Buscando..." : "Próximo disponível") + " ")])], 1), _c('div', {
    staticClass: "agenda-day-title"
  }, [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s(_vm.formattedSelectedDate))]), _c('div', {
    staticClass: "agenda-day-meta"
  }, [_c('span', [_vm._v("Expediente: " + _vm._s(_vm.expedienteLabel))]), _c('span', [_vm._v(_vm._s(_vm.form.duracao_minutos) + " min por agendamento")]), _c('span', [_vm._v(_vm._s(_vm.availableSlotsCount) + " horários livres")])])]), _vm.loadingHorarios ? _c('div', {
    staticClass: "agenda-loading"
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Carregando horários... ")], 1) : _vm.horariosError ? _c('div', {
    staticClass: "alert alert-light-danger"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.horariosError))]), _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadHorarios
    }
  }, [_vm._v(" Tentar novamente ")])])]) : _vm.horarios.expediente && _vm.horarios.expediente.fechado ? _c('div', {
    staticClass: "alert alert-light-warning"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('span', [_vm._v("Domingo não possui expediente padrão para agendamentos.")]), _c('button', {
    staticClass: "btn btn-sm btn-light-warning font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.moveDate(1);
      }
    }
  }, [_vm._v(" Próximo dia ")])])]) : !_vm.hasSlots ? _c('div', {
    staticClass: "agenda-empty"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v(" Nenhum horário foi recebido. ")]), _c('p', {
    staticClass: "text-muted mb-4"
  }, [_vm._v(" Tente recarregar a disponibilidade ou escolha outro dia. ")]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadHorarios
    }
  }, [_vm._v(" Recarregar ")]), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.moveDate(1);
      }
    }
  }, [_vm._v(" Próximo dia ")])]) : _c('div', [!_vm.hasAvailableSlots ? _c('div', {
    staticClass: "agenda-empty mb-5"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v(" Dia sem horários disponíveis. ")]), _c('p', {
    staticClass: "text-muted mb-4"
  }, [_vm._v(" Todos os horários deste responsável estão ocupados para a duração selecionada. ")]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToNextAvailableDate
    }
  }, [_vm._v(" Buscar próximo disponível ")])]) : _vm._e(), _vm._l(_vm.slotGroups, function (group) {
    return _c('div', {
      key: group.label,
      staticClass: "agenda-period"
    }, [_c('div', {
      staticClass: "agenda-period-title"
    }, [_c('h5', [_vm._v(_vm._s(group.label))]), _c('span', [_vm._v(_vm._s(group.available) + " livres de " + _vm._s(group.total))])]), _c('div', {
      staticClass: "agenda-slots"
    }, _vm._l(group.slots, function (slot) {
      return _c('button', {
        key: slot.inicio,
        staticClass: "agenda-slot",
        class: {
          selected: _vm.selectedSlot && _vm.selectedSlot.inicio === slot.inicio,
          unavailable: !slot.disponivel
        },
        attrs: {
          "type": "button",
          "disabled": !slot.disponivel,
          "title": slot.motivo || _vm.slotStatusLabel(slot)
        },
        on: {
          "click": function click($event) {
            return _vm.selectSlot(slot);
          }
        }
      }, [_c('ClockOutline', {
        attrs: {
          "size": 16
        }
      }), _c('span', [_vm._v(_vm._s(_vm.slotLabel(slot)))]), _c('small', [_vm._v(_vm._s(_vm.slotStatusLabel(slot)))])], 1);
    }), 0)]);
  })], 2)]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "agenda-panel"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-4"
  }, [_vm._v("Resumo do horário")]), _c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Profissional:")]), _vm._v(" " + _vm._s(_vm.responsavelLabel) + " ")]), _c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Duração:")]), _vm._v(" " + _vm._s(_vm.form.duracao_minutos) + " min ")]), _c('p', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Selecionado:")]), _vm._v(" " + _vm._s(_vm.selectedSlotLabel) + " ")]), _c('div', {
    staticClass: "agenda-summary-grid mb-5"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.totalSlotsCount))]), _c('span', [_vm._v("Total")])]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.availableSlotsCount))]), _c('span', [_vm._v("Livres")])]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.busySlotsCount))]), _c('span', [_vm._v("Ocupados")])])]), _c('h6', {
    staticClass: "font-weight-bolder mb-3"
  }, [_vm._v("Ocupados no dia")]), _vm.horarios.ocupados.length === 0 ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Nenhum agendamento ocupando este dia. ")]) : _vm._e(), _vm._l(_vm.horarios.ocupados, function (ocupado) {
    return _c('div', {
      key: ocupado.id_agendamento,
      staticClass: "agenda-busy-item"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatTime(ocupado.data_inicio)) + " - " + _vm._s(_vm.formatTime(ocupado.data_fim)))]), _c('span', [_vm._v(_vm._s(ocupado.cliente || "Cliente"))]), _c('small', [_vm._v(_vm._s(ocupado.servico || ocupado.descricao_servico || ocupado.titulo || "Agendamento"))])]);
  })], 2)])], 1)], 1) : _vm._e(), _vm.step === 3 ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "agenda-review"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-5"
  }, [_vm._v("Conferência")]), _c('p', [_c('strong', [_vm._v("Cliente:")]), _vm._v(" " + _vm._s(_vm.form.cliente ? _vm.form.cliente.nome : "-") + " ")]), _c('p', [_c('strong', [_vm._v("Profissional:")]), _vm._v(" " + _vm._s(_vm.responsavelLabel) + " ")]), _c('p', [_c('strong', [_vm._v("Título:")]), _vm._v(" " + _vm._s(_vm.tituloAgendamentoLabel))]), _c('p', [_c('strong', [_vm._v("Data e horário:")]), _vm._v(" " + _vm._s(_vm.selectedSlotLabel))]), _c('p', [_c('strong', [_vm._v("Duração:")]), _vm._v(" " + _vm._s(_vm.form.duracao_minutos) + " min")]), _c('p', [_c('strong', [_vm._v("Observações:")]), _vm._v(" " + _vm._s(_vm.form.observacoes || "-") + " ")])])])], 1)], 1) : _vm._e()]), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.step === 1 ? _vm.cancel() : _vm.step--;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.step === 1 ? "Cancelar" : "Voltar") + " ")]), _vm.step < 3 ? _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.step === 2 && !_vm.selectedSlot
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(" Próximo ")]) : _c('button', {
    ref: "submit_agendamento",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" Salvar ")])])])]), _c('b-modal', {
    attrs: {
      "id": "novoClienteAgendamentoModal",
      "centered": "",
      "size": "xl",
      "title": "Novo Cliente",
      "hide-footer": "",
      "body-class": "p-0 novo-cliente-agendamento-modal-body"
    },
    on: {
      "hidden": _vm.resetNovoClienteModal
    }
  }, [_c('PessoaForm', {
    attrs: {
      "url": "/pessoa/create",
      "pessoa": _vm.novaPessoa,
      "hide-tipo-pessoa": true,
      "force-cliente": true,
      "redirect-on-save": false
    },
    on: {
      "saved": _vm.handleNovoClienteSaved,
      "cancel": function cancel($event) {
        return _vm.$bvModal.hide('novoClienteAgendamentoModal');
      }
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };